import { render, staticRenderFns } from "./cart_list.vue?vue&type=template&id=51876967&scoped=true"
import script from "./cart_list.vue?vue&type=script&lang=js"
export * from "./cart_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51876967",
  null
  
)

export default component.exports